import * as Style from './styles';

export const ListItemTitle = ({text, openSidebar}) => {
    return(
        <Style.BoxContainerInfoSideBar>
            {openSidebar && <p>{text}</p>}
        </Style.BoxContainerInfoSideBar>
    )
}